//React components
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Nav from 'react-bootstrap/Nav';
import moment from 'moment-timezone';
import ModalselectList from './ModalWarehouse/ModalselectList';
import Select from 'react-select'
//API
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { WarehouseFetchAPI } from '../../api/Warehouse';
import { InventoryFetchAPI } from '../../api/Inventory';

//Internal components 
import NavBar from '../NavBar/Navbar';
import ReportTable from '../reports/table/ReportTable';
import Table from '../Table/Table';
//Modals 
import SuccessAlert from '../Alerts/SuccessAlert';
import ModalBranchofficeSelect from '../NavBar/ModalBranchofficeSelect';
import ErrorAlert from '../Alerts/ErrorAlert';
const Report = ({ selectedBranch, warehouses, setWarehouses }) => {
    //We get the user data 
    let user = JSON.parse(localStorage.getItem('user'))
    let token = localStorage.getItem('x-access-token');
    //States 
    const [eventHandler, setEventHandler] = useState(0)
    const [warehouseselected, setWarehouseSelected] = useState(0);
    const [warehouseselectedname, setWarehouseSelectedname] = useState("Selecciona una bodega");
    const [userBranchoffices, setUserBranchs] = useState([]);
    const [movements, setMovements] = useState([])
    const [inventoryGroups, setInventoryGroups] = useState([])
    const [inventoryTotal, setinventoryTotal] = useState(0)
    const [initialDate, setInitialDate] = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD') + 'T00:00:00.000+00:00');
    const [maxDate, setMaxDate] = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD') + 'T23:59:59.000+00:00')



    const actionselectWarehouse = (data) => {
        setWarehouseSelectedname(data.name)
        setWarehouseSelected(data.id)
        getInventoryByWarehouse(data.id)
        getInventoryMovementsByWarehouse(data.id)
    }

    //Function get Inventory 
    const getInventoryByWarehouse = async (data) => {
        let warehouse_id = warehouseselected
        if (data != undefined) {
            warehouse_id = data
        }
        if (warehouse_id != 0) {

            try {
                const response = await InventoryFetchAPI.getInventoryBywarehouse(warehouse_id, token)
                setInventoryGroups(response.data.inventory)
                let total = 0
                response.data.inventory.forEach(product => {
                    total = (total + product.quantity)
                });

                setinventoryTotal(total)

            } catch (err) {
                setInventoryGroups([])
                setinventoryTotal(0)
                ErrorAlert(err.response.data.message, 'Error de consulta', 'error')
                console.log(err);
            }

        } else {
            ErrorAlert('', 'Seleccione una bodega', 'warning')
        }
    }

    //Function to get the movements of the inventory
    const getInventoryMovementsByWarehouse = async (data) => {
        let warehouse_id = warehouseselected
        if (data != undefined) {
            warehouse_id = data
        }
        try {
            const response = await InventoryFetchAPI.getInventoryMovements(warehouse_id, token, undefined, initialDate, maxDate)
            setMovements(response.data.movements)
        } catch (err) {
            console.log(err);
        }
    }

    //Function to download the report
    const downloadReport = async () => {
        try {
            const response = await InventoryFetchAPI.downloandInventoryReport(warehouseselected, token, initialDate, maxDate);
            //We check if the response is ok
            if (response == false) {
                ErrorAlert('No se pudo descargar el reporte', 'Error de descarga', 'error')
            }
        } catch (err) {
            ErrorAlert(err.response.data.message, 'Error de consulta', 'error')
            console.log(err);
        }
    }
    //Function to populate the warehouses
    const warehouseList = () => {
        const listWarehouse = warehouses.map((warehouse) => (
            <>
                <option value={warehouse.id}>{warehouse.name}</option>
            </>
        ));
        return listWarehouse
    }



    //Hook to load the initial data 
    useEffect(() => {
        //We set the branchoffices of the user 
        setUserBranchs(user.branchoffices);

    }, []);

    return (
        <>
            <div className='m-0'>

                <h5 className='fw-bold text-primary mt-2'>Filtros</h5>
                <div className="row gx-3 gy-2 align-items-center bg-white p-2 my-3 border-sp border shadow-sm">

                    <div className="col-sm-6 col-md-6 col-lg-6">
                        <div className="form-group">
                            <label htmlFor="input_from">Desde</label>
                            <input type="date" name="initialDate" onChange={e => setInitialDate(e.target.value + "T00:00:00.000+00:00")} className="control mt-3" />
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                        <div className="form-group">
                            <label htmlFor="input_from">Hasta</label>
                            <input type="date" name="finishDate" onChange={e => setMaxDate(e.target.value + "T23:59:59.000+00:00")} className="control mt-3" />
                        </div>
                    </div>

                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <div className="form-group">
                            <label htmlFor="warehouse">Bodegas</label>
                            {/* <select className='form-select w-100' name="warehouse" id="warehouse" onChange={(e) => setWarehouseSelected(e.target.value)}>
                                <option value={0}>Selecciona una bodega</option>
                                {warehouseList()}
                            </select>*/}
                        </div>

                        <ModalselectList action={actionselectWarehouse} dataArray={warehouses} title={"Selecciona una bodega"} dataselected={warehouseselectedname} section={"Bodegas"}></ModalselectList>
                    </div>
                    <div className=" d-flex justify-content-center justify-content-sm-end mb-3">
                        <button type="button" className="btn btn-success px-5" onClick={() => (getInventoryByWarehouse(), getInventoryMovementsByWarehouse())}>Aceptar</button>
                    </div>
                </div>


                <Tab.Container defaultActiveKey="report">
                    <Row>
                        <Col sm={12} >
                            <Nav variant="underline" className="d-flex horizontal-scroll border-bottom  pe-3 ">
                                <li className="nav-sp-item">
                                    <Nav.Link eventKey="report" title="Reportes" ><i className="uil uil-file-graph"></i> Inventario</Nav.Link>
                                </li>
                                <li className="nav-sp-item"  >
                                    <Nav.Link eventKey="movements" title="Movimientos" ><i className="uil uil-file-search-alt"></i> Movimientos</Nav.Link>
                                </li>

                            </Nav>
                        </Col>
                        <Col sm={12}>
                            <Tab.Content>
                                <Tab.Pane eventKey="report" title="Reportes inventario">
                                    {inventoryGroups.length > 0 ? <>
                                        <section className=''>

                                            <div className="d-lg-flex justify-content-lg-between d-none mt-3">
                                                <h5 className="fw-bold text-primary">Totales de inventario </h5>

                                            </div>

                                            <div className="row justify-content-md-center mt-1">
                                                <div className="col-6 col-md-6 col-lg-6  ">
                                                    <div className="card-analitics-sp shadow-sm">
                                                        <div className="card-analitics-sp-header d-flex justify-content-between">
                                                            <span>Cantidad de productos</span>
                                                        </div>
                                                        <span className="card-value-total fw-bold text-color-sp">{inventoryGroups.length}</span>
                                                    </div>
                                                </div>
                                                <div className="col-6 col-md-6 col-lg-6">
                                                    <div className="card-analitics-sp shadow-sm">
                                                        <div className="card-analitics-sp-header d-flex justify-content-between">
                                                            <span>Inventario total</span>
                                                        </div>
                                                        <span className="card-value-total fw-bold text-color-sp"> {inventoryTotal}</span>
                                                    </div>
                                                </div>
                                            </div>


                                            <ReportTable
                                                table_name="Tabla de inventario"
                                                table_headers={["Grupo", "Cantidad"]}
                                                table_type="inventory_report"
                                                table_data={inventoryGroups}
                                                downloadReport={downloadReport}
                                            />

                                        </section>
                                    </> : <></>}
                                </Tab.Pane>

                                <Tab.Pane eventKey="movements">
                                    <section className=''>
                                        <ReportTable
                                            table_name="Tabla de movimientos de inventario"
                                            table_headers={["Producto", "Cantidad", "Tipo moviemiento", "Razon", "Nota", "Bodega raiz", "Bodega destino", "Usuario", "Fecha"]}
                                            table_type="movements_report"
                                            table_data={movements}
                                            downloadReport={downloadReport}

                                        />

                                    </section>
                                </Tab.Pane>


                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>


            </div>
        </>
    );
}

export default Report;
